import { render } from "./PaymentCheckoutHeader.vue?vue&type=template&id=675cc5dd"
import script from "./PaymentCheckoutHeader.vue?vue&type=script&lang=js"
export * from "./PaymentCheckoutHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__